export enum AppName {
  Frontend = 'frontend',
  Admin = 'admin',
}
